



let initStore = {
          
    esacLoading: false,
    esacError: false,
    locationLoading: false,
    locationError: false,
    
    locationData: {
        /*svdec18 y25 start*/
        svcli_meta_data:{ "port": [
            {
                "code": "SVALL",
                "label": "Any Port",
                "enabled": true
            }]
        },
        /*
        svcli_meta_data:{
            
            "dest": [
                {
                    "REGION_ID": 3333,
                    "CODE": "SVALL",
                    "SHORT_NAME": "Any Destination",
                    "LABEL": "Any Destination",
                    "ENABLED": 1,
                    "PORTSDEST":[{
                        "CODE": "SVALL",
                        "LABEL": "SVALL",
                        "enabled": true
                    }]
                    
                },
                {
                    "REGION_ID": 53,
                    "CODE": "ALK",
                    "SHORT_NAME": "Alaska",
                    "LABEL": "Alaska",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 41,
                            "CODE" : "TFJ",
                            "LABEL" : "Cruise Tracy Arm Fjord",
                            "ENABLED" : 1,
                            "REGION_ID" : 53
                        },
                        {
                            "ID" : 42,
                            "CODE" : "SKY",
                            "LABEL" : "Skagway",
                            "ENABLED" : 1,
                            "REGION_ID" : 53
                        },
                        {
                            "ID" : 43,
                            "CODE" : "JNU",
                            "LABEL" : "Juneau",
                            "ENABLED" : 1,
                            "REGION_ID" : 53
                        },
                        {
                            "ID" : 44,
                            "CODE" : "KTN",
                            "LABEL" : "Ketchikan",
                            "ENABLED" : 1,
                            "REGION_ID" : 53
                        },
                        {
                            "ID" : 45,
                            "CODE" : "YYJ",
                            "LABEL" : "Victoria",
                            "ENABLED" : 1,
                            "REGION_ID" : 53
                        }
                    ]
                    
                   
                    
                },
                {
                    "REGION_ID": 54,
                    "CODE": "BAH",
                    "SHORT_NAME": "Bahmas",
                    "LABEL": "Bahmas",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 38,
                            "CODE" : "NAS",
                            "LABEL" : "Nassau, Bahamas",
                            "ENABLED" : 1,
                            "REGION_ID" : 54
                        },
                        {
                            "ID" : 52,
                            "CODE" : "FPO",
                            "LABEL" : "New Port",
                            "ENABLED" : 1,
                            "REGION_ID" : 54
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 55,
                    "CODE": "HAW",
                    "SHORT_NAME": "Hawaii",
                    "LABEL": "Hawaii",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 28,
                            "CODE" : "KOA",
                            "LABEL" : "Kona, Hawaii",
                            "ENABLED" : 1,
                            "REGION_ID" : 55
                        },
                        {
                            "ID" : 29,
                            "CODE" : "ITO",
                            "LABEL" : "Hilo, Hawaii",
                            "ENABLED" : 1,
                            "REGION_ID" : 55
                        },
                        {
                            "ID" : 30,
                            "CODE" : "OGG",
                            "LABEL" : "Kahului, Maui",
                            "ENABLED" : 1,
                            "REGION_ID" : 55
                        },
                        {
                            "ID" : 31,
                            "CODE" : "HNL",
                            "LABEL" : "Honolulu Harbor,Hawaii",
                            "ENABLED" : 1,
                            "REGION_ID" : 55
                        },
                        {
                            "ID" : 40,
                            "CODE" : "NWK",
                            "LABEL" : "Nāwiliwili, Kaua",
                            "ENABLED" : 1,
                            "REGION_ID" : 55
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 56,
                    "CODE": "CAN",
                    "SHORT_NAME": "Canada,England",
                    "LABEL": "Canada & New England",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 14,
                            "CODE" : "NYC",
                            "LABEL" : "Manhattan, New York City, NY",
                            "ENABLED" : 1,
                            "REGION_ID" : 56
                        },
                        {
                            "ID" : 53,
                            "CODE" : "BHB",
                            "LABEL" : "Bar Harbor",
                            "ENABLED" : 1,
                            "REGION_ID" : 56
                        },
                        {
                            "ID" : 54,
                            "CODE" : "PVD",
                            "LABEL" : "New Port, Rhode",
                            "ENABLED" : 1,
                            "REGION_ID" : 56
                        },
                        {
                            "ID" : 55,
                            "CODE" : "BOS",
                            "LABEL" : "BOSTON",
                            "ENABLED" : 1,
                            "REGION_ID" : 56
                        },
                        {
                            "ID" : 56,
                            "CODE" : "BDL",
                            "LABEL" : "New Haven",
                            "ENABLED" : 1,
                            "REGION_ID" : 56
                        },
                        {
                            "ID" : 57,
                            "CODE" : "YHZ",
                            "LABEL" : "Halifax",
                            "ENABLED" : 1,
                            "REGION_ID" : 56
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 57,
                    "CODE": "CAR",
                    "SHORT_NAME": "Carribean",
                    "LABEL": "Carribean",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 17,
                            "CODE" : "MOB",
                            "LABEL" : "Mobile, AL",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 32,
                            "CODE" : "POP",
                            "LABEL" : "Puerto Plata, Dominican Republic",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 33,
                            "CODE" : "STT",
                            "LABEL" : "St. Thomas, US Virgin Islands",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 34,
                            "CODE" : "TOV",
                            "LABEL" : "Tortola, British Virgin Islands",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 35,
                            "CODE" : "NPI",
                            "LABEL" : "Great Stirrup Cay, Bahamas",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 36,
                            "CODE" : "CZM",
                            "LABEL" : "Cozumel, Mexico",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 37,
                            "CODE" : "RTB",
                            "LABEL" : "Roatan (Bay Islands), Honduras",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 46,
                            "CODE" : "BPI",
                            "LABEL" : "Harvest Caye, Belize",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        },
                        {
                            "ID" : 47,
                            "CODE" : "CMA",
                            "LABEL" : "Costa Maya, Mexico",
                            "ENABLED" : 1,
                            "REGION_ID" : 57
                        }
                    ]
                    
                    
                },
                {
                    "REGION_ID": 58,
                    "CODE": "EUR",
                    "SHORT_NAME": "Europe",
                    "LABEL": "Europe",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 4,
                            "CODE" : "BCN",
                            "LABEL" : "Barcelona, Spain",
                            "ENABLED" : 1,
                            "REGION_ID" : 58
                        },
                        {
                            "ID" : 7,
                            "CODE" : "CIV",
                            "LABEL" : "Civitavecchia (Rome), Italy",
                            "ENABLED" : 1,
                            "REGION_ID" : 58
                        },
                        {
                            "ID" : 11,
                            "CODE" : "LIS",
                            "LABEL" : "Lisbon, Portugal",
                            "ENABLED" : 1,
                            "REGION_ID" : 58
                        },
                        {
                            "ID" : 12,
                            "CODE" : "LON",
                            "LABEL" : "London, England",
                            "ENABLED" : 1,
                            "REGION_ID" : 58
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 59,
                    "CODE": "MEX",
                    "SHORT_NAME": "Mexico",
                    "LABEL": "Mexico",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 49,
                            "CODE" : "PVR",
                            "LABEL" : "Puerto Vallarta, Mexico",
                            "ENABLED" : 1,
                            "REGION_ID" : 59
                        },
                        {
                            "ID" : 50,
                            "CODE" : "MZT",
                            "LABEL" : "Mazatlan, Mexico",
                            "ENABLED" : 1,
                            "REGION_ID" : 59
                        },
                        {
                            "ID" : 51,
                            "CODE" : "CSL",
                            "LABEL" : "Cabo San Lucas, Mexico",
                            "ENABLED" : 1,
                            "REGION_ID" : 59
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 60,
                    "CODE": "PAN",
                    "SHORT_NAME": "Panama Canal",
                    "LABEL": "Panama Canal",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 60,
                            "CODE" : "PTY",
                            "LABEL" : "Balboa",
                            "ENABLED" : 1,
                            "REGION_ID" : 60
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 61,
                    "CODE": "SAM",
                    "SHORT_NAME": "South America",
                    "LABEL": "South America",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 6,
                            "CODE" : "BUE",
                            "LABEL" : "Buenos Aires, Argentina",
                            "ENABLED" : 1,
                            "REGION_ID" : 61
                        },
                        {
                            "ID" : 61,
                            "CODE" : "GIG",
                            "LABEL" : "Rio de Janeiro",
                            "ENABLED" : 1,
                            "REGION_ID" : 61
                        },
                        {
                            "ID" : 62,
                            "CODE" : "EZE",
                            "LABEL" : "Buenos Aires",
                            "ENABLED" : 1,
                            "REGION_ID" : 61
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 62,
                    "CODE": "TRA",
                    "SHORT_NAME": "Transpacific",
                    "LABEL": "Transpacific",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 9,
                            "CODE" : "HKG",
                            "LABEL" : "Hong Kong",
                            "ENABLED" : 1,
                            "REGION_ID" : 62
                        },
                        {
                            "ID" : 21,
                            "CODE" : "SAI",
                            "LABEL" : "San Antonio (Santiago), Chile",
                            "ENABLED" : 1,
                            "REGION_ID" : 62
                        },
                        {
                            "ID" : 22,
                            "CODE" : "SFO",
                            "LABEL" : "San Francisco, CA",
                            "ENABLED" : 1,
                            "REGION_ID" : 62
                        },
                        {
                            "ID" : 23,
                            "CODE" : "SEA",
                            "LABEL" : "Seattle, WA",
                            "ENABLED" : 1,
                            "REGION_ID" : 62
                        },
                        {
                            "ID" : 24,
                            "CODE" : "SIN",
                            "LABEL" : "Singapore",
                            "ENABLED" : 1,
                            "REGION_ID" : 62
                        },
                        {
                            "ID" : 27,
                            "CODE" : "TYO",
                            "LABEL" : "Tokyo, Japan",
                            "ENABLED" : 1,
                            "REGION_ID" : 62
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 63,
                    "CODE": "AUS",
                    "SHORT_NAME": "Australia",
                    "LABEL": "Australia",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 1,
                            "CODE" : "ADL",
                            "LABEL" : "Adelaide, Australia",
                            "ENABLED" : 0,
                            "REGION_ID" : 63
                        },
                        {
                            "ID" : 5,
                            "CODE" : "BNE",
                            "LABEL" : "Brisbane, Australia",
                            "ENABLED" : 1,
                            "REGION_ID" : 63
                        },
                        {
                            "ID" : 15,
                            "CODE" : "MEL",
                            "LABEL" : "Melbourne, Australia",
                            "ENABLED" : 1,
                            "REGION_ID" : 63
                        },
                        {
                            "ID" : 25,
                            "CODE" : "SYD",
                            "LABEL" : "Sydney, Australia",
                            "ENABLED" : 1,
                            "REGION_ID" : 63
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 64,
                    "CODE": "NZW",
                    "SHORT_NAME": "New Zealan",
                    "LABEL": "New Zealan",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 2,
                            "CODE" : "AKL",
                            "LABEL" : "Auckland, New Zealand",
                            "ENABLED" : 1,
                            "REGION_ID" : 64
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 65,
                    "CODE": "SPA",
                    "SHORT_NAME": "South Pacific",
                    "LABEL": "South Pacific",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 59,
                            "CODE" : "VLI",
                            "LABEL" : "Port Vila",
                            "ENABLED" : 1,
                            "REGION_ID" : 65
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 66,
                    "CODE": "KEY",
                    "SHORT_NAME": "Celebration Key",
                    "LABEL": "Celebration Key",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 38,
                            "CODE" : "NAS",
                            "LABEL" : "Nassau, Bahamas",
                            "ENABLED" : 1,
                            "REGION_ID" : 66
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 67,
                    "CODE": "ROA",
                    "SHORT_NAME": "Tropicane Roatan",
                    "LABEL": "Isla Tropicane, Roatan",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 37,
                            "CODE" : "RTB",
                            "LABEL" : "Roatán (Bay Islands), Honduras",
                            "ENABLED" : 1,
                            "REGION_ID" : 67
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 68,
                    "CODE": "CAY",
                    "SHORT_NAME": "Half Moon Cay",
                    "LABEL": "RelaxAway Half Moon Cay",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 52,
                            "CODE" : "FPO",
                            "LABEL" : "Great Stirrup Cay, Bahmas",
                            "ENABLED" : 1,
                            "REGION_ID" : 68
                        }
                    ]
                    
                },
                {
                    "REGION_ID": 69,
                    "CODE": "BER",
                    "SHORT_NAME": "Bermuda",
                    "LABEL": "Bermuda",
                    "ENABLED": 1,
                    "PORTSDEST":[
                        {
                            "ID" : 58,
                            "CODE" : "BDA",
                            "LABEL" : "Royal Naval Dockyard,Bermuda",
                            "ENABLED" : 1,
                            "REGION_ID" : 69
                        }
                    ]
                    
                }
            ],
            "portCall": [
                {
                    "code": "ALL",
                    "label": "All Ports",
                    "enabled": false
                },
                {
                    "code": "ADL",
                    "label": "Adelaide, Australia",
                    "enabled": false
                },
                {
                    "code": "AKL",
                    "label": "Auckland, New Zealand",
                    "enabled": false
                },
                {
                    "code": "BWI",
                    "label": "Baltimore, MD",
                    "enabled": false
                },
                {
                    "code": "BCN",
                    "label": "Barcelona, Spain",
                    "enabled": false
                },
                {
                    "code": "BNE",
                    "label": "Brisbane, Australia",
                    "enabled": false
                },
                {
                    "code": "BUE",
                    "label": "Buenos Aires, Argentina",
                    "enabled": false
                },
                {
                    "code": "CIV",
                    "label": "Civitavecchia (Rome), Italy",
                    "enabled": false
                },
                {
                    "code": "GAL",
                    "label": "Galveston, TX",
                    "enabled": false
                },
                {
                    "code": "HKG",
                    "label": "Hong Kong\n\n\n",
                    "enabled": false
                },
                {
                    "code": "JAX",
                    "label": "Jacksonville, FL",
                    "enabled": false
                },
                {
                    "code": "LIS",
                    "label": "Lisbon, Portugal",
                    "enabled": false
                },
                {
                    "code": "LON",
                    "label": "London, England",
                    "enabled": false
                },
                {
                    "code": "LAX",
                    "label": "Los Angeles, CA",
                    "enabled": false
                },
                {
                    "code": "NYC",
                    "label": "Manhattan, New York City, NY",
                    "enabled": false
                },
                {
                    "code": "MEL",
                    "label": "Melbourne, Australia",
                    "enabled": false
                },
                {
                    "code": "MIA",
                    "label": "Miami, FL",
                    "enabled": false
                },
                {
                    "code": "MOB",
                    "label": "Mobile, AL",
                    "enabled": false
                },
                {
                    "code": "MSY",
                    "label": "New Orleans, LA",
                    "enabled": false
                },
                {
                    "code": "ORF",
                    "label": "Norfolk, VA",
                    "enabled": false
                },
                {
                    "code": "PCV",
                    "label": "Port Canaveral (Orlando), FL",
                    "enabled": false
                },
                {
                    "code": "SAI",
                    "label": "San Antonio (Santiago), Chile",
                    "enabled": false
                },
                {
                    "code": "SFO",
                    "label": "San Francisco, CA",
                    "enabled": false
                },
                {
                    "code": "SEA",
                    "label": "Seattle, WA",
                    "enabled": true
                },
                {
                    "code": "SIN",
                    "label": "Singapore",
                    "enabled": false
                },
                {
                    "code": "SYD",
                    "label": "Sydney, Australia",
                    "enabled": false
                },
                {
                    "code": "TPA",
                    "label": "Tampa, FL",
                    "enabled": false
                },
                {
                    "code": "TYO",
                    "label": "Tokyo, Japan",
                    "enabled": false
                }
            ],
            "port": [
                {
                    "code": "SVALL",
                    "label": "Any Port",
                    "enabled": true
                },
                {
                    "code": "ADL",
                    "label": "Adelaide, Australia",
                    "enabled": false
                },
                {
                    "code": "AKL",
                    "label": "Auckland, New Zealand",
                    "enabled": false
                },
                {
                    "code": "BWI",
                    "label": "Baltimore, MD",
                    "enabled": false
                },
                {
                    "code": "BCN",
                    "label": "Barcelona, Spain",
                    "enabled": false
                },
                {
                    "code": "BNE",
                    "label": "Brisbane, Australia",
                    "enabled": false
                },
                {
                    "code": "BUE",
                    "label": "Buenos Aires, Argentina",
                    "enabled": false
                },
                {
                    "code": "CIV",
                    "label": "Civitavecchia (Rome), Italy",
                    "enabled": false
                },
                {
                    "code": "GAL",
                    "label": "Galveston, TX",
                    "enabled": false
                },
                {
                    "code": "HKG",
                    "label": "Hong Kong\n\n\n",
                    "enabled": false
                },
                {
                    "code": "JAX",
                    "label": "Jacksonville, FL",
                    "enabled": false
                },
                {
                    "code": "LIS",
                    "label": "Lisbon, Portugal",
                    "enabled": false
                },
                {
                    "code": "LON",
                    "label": "London, England",
                    "enabled": false
                },
                {
                    "code": "LAX",
                    "label": "Los Angeles, CA",
                    "enabled": false
                },
                {
                    "code": "NYC",
                    "label": "Manhattan, New York City, NY",
                    "enabled": false
                },
                {
                    "code": "MEL",
                    "label": "Melbourne, Australia",
                    "enabled": false
                },
                {
                    "code": "MIA",
                    "label": "Miami, FL",
                    "enabled": false
                },
                {
                    "code": "MOB",
                    "label": "Mobile, AL",
                    "enabled": false
                },
                {
                    "code": "MSY",
                    "label": "New Orleans, LA",
                    "enabled": false
                },
                {
                    "code": "ORF",
                    "label": "Norfolk, VA",
                    "enabled": false
                },
                {
                    "code": "PCV",
                    "label": "Port Canaveral (Orlando), FL",
                    "enabled": false
                },
                {
                    "code": "SAI",
                    "label": "San Antonio (Santiago), Chile",
                    "enabled": false
                },
                {
                    "code": "SFO",
                    "label": "San Francisco, CA",
                    "enabled": false
                },
                {
                    "code": "SEA",
                    "label": "Seattle, WA",
                    "enabled": true
                },
                {
                    "code": "SIN",
                    "label": "Singapore",
                    "enabled": false
                },
                {
                    "code": "SYD",
                    "label": "Sydney, Australia",
                    "enabled": false
                },
                {
                    "code": "TPA",
                    "label": "Tampa, FL",
                    "enabled": false
                },
                {
                    "code": "TYO",
                    "label": "Tokyo, Japan",
                    "enabled": false
                }
            ],
            "durDays": [
                {
                    "code": "2",
                    "label": "2 Days",
                    "enabled": false
                },
                {
                    "code": "3",
                    "label": "3 Days",
                    "enabled": false
                },
                {
                    "code": "4",
                    "label": "4 Days",
                    "enabled": false
                },
                {
                    "code": "5",
                    "label": "5 Days",
                    "enabled": false
                },
                {
                    "code": "6",
                    "label": "6 Days",
                    "enabled": false
                },
                {
                    "code": "7",
                    "label": "7 Days",
                    "enabled": true
                },
                {
                    "code": "8",
                    "label": "8 Days",
                    "enabled": false
                },
                {
                    "code": "9",
                    "label": "9 Days",
                    "enabled": false
                },
                {
                    "code": "10",
                    "label": "10 Days",
                    "enabled": false
                },
                {
                    "code": "11",
                    "label": "11 Days",
                    "enabled": false
                },
                {
                    "code": "12",
                    "label": "12 Days",
                    "enabled": false
                },
                {
                    "code": "13",
                    "label": "13 Days",
                    "enabled": false
                },
                {
                    "code": "14",
                    "label": "14 Days",
                    "enabled": false
                },
                {
                    "code": "15",
                    "label": "15 Days",
                    "enabled": false
                },
                {
                    "code": "16",
                    "label": "16 Days",
                    "enabled": false
                },
                {
                    "code": "22",
                    "label": "22 Days",
                    "enabled": false
                },
                {
                    "code": "23",
                    "label": "23 Days",
                    "enabled": false
                }
            ],
            "dur": [
                {
                    "code": "SVALL",
                    "label": "All Durations",
                    "enabled": true
                },
                {
                    "code": "D1",
                    "label": "2 - 5 Days",
                    "enabled": false
                },
                {
                    "code": "D2",
                    "label": "6 - 9 Days",
                    "enabled": true
                },
                {
                    "code": "D3",
                    "label": "10+ Days",
                    "enabled": false
                }
            ],
            "datFrom": [
                {
                    "code": "122025",
                    "label": "Dec 2025",
                    "enabled": false
                },
                {
                    "code": "012026",
                    "label": "Jan 2026",
                    "enabled": false
                },
                {
                    "code": "022026",
                    "label": "Feb 2026",
                    "enabled": false
                },
                {
                    "code": "032026",
                    "label": "Mar 2026",
                    "enabled": false
                },
                {
                    "code": "042026",
                    "label": "Apr 2026",
                    "enabled": true
                },
                {
                    "code": "052026",
                    "label": "May 2026",
                    "enabled": true
                },
                {
                    "code": "062026",
                    "label": "Jun 2026",
                    "enabled": true
                },
                {
                    "code": "072026",
                    "label": "Jul 2026",
                    "enabled": true
                },
                {
                    "code": "082026",
                    "label": "Aug 2026",
                    "enabled": true
                },
                {
                    "code": "092026",
                    "label": "Sep 2026",
                    "enabled": true
                },
                {
                    "code": "102026",
                    "label": "Oct 2026",
                    "enabled": false
                },
                {
                    "code": "112026",
                    "label": "Nov 2026",
                    "enabled": false
                },
                {
                    "code": "122026",
                    "label": "Dec 2026",
                    "enabled": false
                },
                {
                    "code": "012027",
                    "label": "Jan 2027",
                    "enabled": false
                },
                {
                    "code": "022027",
                    "label": "Feb 2027",
                    "enabled": false
                },
                {
                    "code": "032027",
                    "label": "Mar 2027",
                    "enabled": false
                },
                {
                    "code": "042027",
                    "label": "Apr 2027",
                    "enabled": true
                },
                {
                    "code": "052027",
                    "label": "May 2027",
                    "enabled": true
                },
                {
                    "code": "062027",
                    "label": "Jun 2027",
                    "enabled": true
                },
                {
                    "code": "072027",
                    "label": "Jul 2027",
                    "enabled": true
                },
                {
                    "code": "082027",
                    "label": "Aug 2027",
                    "enabled": true
                },
                {
                    "code": "092027",
                    "label": "Sep 2027",
                    "enabled": true
                },
                {
                    "code": "102027",
                    "label": "Oct 2027",
                    "enabled": false
                },
                {
                    "code": "112027",
                    "label": "Nov 2027",
                    "enabled": false
                },
                {
                    "code": "122027",
                    "label": "Dec 2027",
                    "enabled": false
                },
                {
                    "code": "012028",
                    "label": "Jan 2028",
                    "enabled": false
                },
                {
                    "code": "022028",
                    "label": "Feb 2028",
                    "enabled": false
                },
                {
                    "code": "032028",
                    "label": "Mar 2028",
                    "enabled": false
                },
                {
                    "code": "042028",
                    "label": "Apr 2028",
                    "enabled": false
                },
                {
                    "code": "052028",
                    "label": "May 2028",
                    "enabled": false
                },
                {
                    "code": "062028",
                    "label": "Jun 2028",
                    "enabled": false
                },
                {
                    "code": "072028",
                    "label": "Jul 2028",
                    "enabled": false
                }
            ],
            "shipCode": [
                {
                    "code": "SVALL",
                    "label": "All Ships",
                    "enabled": true
                },
                {
                    "code": "AQ",
                    "label": "Carnival Adventure",
                    "enabled": false
                },
                {
                    "code": "BR",
                    "label": "Carnival Breeze",
                    "enabled": false
                },
                {
                    "code": "CB",
                    "label": "Carnival Celebration",
                    "enabled": false
                },
                {
                    "code": "CQ",
                    "label": "Carnival Conquest",
                    "enabled": false
                },
                {
                    "code": "DR",
                    "label": "Carnival Dream",
                    "enabled": false
                },
                {
                    "code": "EL",
                    "label": "Carnival Elation",
                    "enabled": false
                },
                {
                    "code": "EQ",
                    "label": "Carnival Encounter",
                    "enabled": false
                },
                {
                    "code": "FT",
                    "label": "Carnival Festivale",
                    "enabled": false
                },
                {
                    "code": "FN",
                    "label": "Carnival Firenze",
                    "enabled": false
                },
                {
                    "code": "FD",
                    "label": "Carnival Freedom",
                    "enabled": false
                },
                {
                    "code": "GL",
                    "label": "Carnival Glory",
                    "enabled": false
                },
                {
                    "code": "HZ",
                    "label": "Carnival Horizon",
                    "enabled": false
                },
                {
                    "code": "JB",
                    "label": "Carnival Jubilee",
                    "enabled": false
                },
                {
                    "code": "LE",
                    "label": "Carnival Legend",
                    "enabled": false
                },
                {
                    "code": "LI",
                    "label": "Carnival Liberty",
                    "enabled": false
                },
                {
                    "code": "LM",
                    "label": "Carnival Luminosa",
                    "enabled": false
                },
                {
                    "code": "MC",
                    "label": "Carnival Magic",
                    "enabled": false
                },
                {
                    "code": "MI",
                    "label": "Carnival Miracle",
                    "enabled": true
                },
                {
                    "code": "PO",
                    "label": "Carnival Panorama",
                    "enabled": false
                },
                {
                    "code": "PA",
                    "label": "Carnival Paradise",
                    "enabled": false
                },
                {
                    "code": "PR",
                    "label": "Carnival Pride",
                    "enabled": false
                },
                {
                    "code": "RD",
                    "label": "Carnival Radiance",
                    "enabled": false
                },
                {
                    "code": "SP",
                    "label": "Carnival Spirit",
                    "enabled": true
                },
                {
                    "code": "SL",
                    "label": "Carnival Splendor",
                    "enabled": false
                },
                {
                    "code": "SN",
                    "label": "Carnival Sunrise",
                    "enabled": false
                },
                {
                    "code": "SH",
                    "label": "Carnival Sunshine",
                    "enabled": false
                },
                {
                    "code": "VA",
                    "label": "Carnival Valor",
                    "enabled": false
                },
                {
                    "code": "VX",
                    "label": "Carnival Venezia",
                    "enabled": false
                },
                {
                    "code": "VS",
                    "label": "Carnival Vista",
                    "enabled": false
                },
                {
                    "code": "MD",
                    "label": "Mardi Gras",
                    "enabled": false
                }
            ],
            "specials": [
                {
                    "code": "J",
                    "label": "Carnival Journeys",
                    "enabled": false
                },
                {
                    "code": "USA250",
                    "label": "America's 250th Birthday",
                    "enabled": false
                },
                {
                    "code": "CARNIVAL55",
                    "label": "Carnival's 55th Birthday",
                    "enabled": false
                },
                {
                    "code": "ECLIPSE",
                    "label": "Solar Eclipse Cruising",
                    "enabled": false
                }
            ],
            "svbrand":[
                {
                    "code": "SVALL",
                    "label": "All Cruises",
                    "enabled": true
                },
                {
                    "code": "RCCL",
                    "label": "RoyalCarribean,Celebrity,SeverSeas",
                    "enabled": true
                },
                {
                    "code": "MSC",
                    "label": "MSC Cruises",
                    "enabled": true
                },
                {
                    "code": "CARN",
                    "label": "Carnival Cruises",
                    "enabled": true
                }
            ],
            
            
            
            svpageSize:5
            
    
        }, */
        /*svdec18 end*/
        startDate : new Date(),
        endDate : new Date(),
        dataSourceSV : ['Burns Bay Road', 'Downing Street', 'Wall Street'],
     
       // "startDate": "2024-07-22T23:42:55.795+00:00" ,
       // "endDate": "2024-07-22T25:42:55.795+00:00" ,
        "hotels":[
            { value: 'jenServer', label: 'jenServer' },
            { value: 'kenServer', label: 'kenServer' },
            { value: 'benServer', label: 'benServer' }
          ],
          "hotelsSelected":{"value": "kenServer", "label": "kenServer"},
        "ddData": [
            {
                "sojourncode": "400",
                "locationdata": " Hilton, 253 scottland av, alabany city, ny 12120, us",
                "address_line1": " 253 scottland av",
                "address_line2": "albany "
            },
            {
                "sojourncode": "410",
                "locationdata": " Hyatt, 153 scottland av, alabany city, ny 12130, us",
                "address_line1": " 410 scottland av",
                "address_line2": "albany "
            },
            {
                "sojourncode": "420",
                "locationdata": " Ramada, 442 scottland av, alabany city, ny 12130, us",
                "address_line1": " 442 scottland av",
                "address_line2": "albany "
            },
            {
                "sojourncode": "430",
                "locationdata": " Econolodge, 253 scottland av, alabany city, ny 12130, us",
                "address_line1": " 430 scottland av",
                "address_line2": "albany "
            }
        ]
    }
}


export default (store = initStore, action) => {

    console.log(action);
    const ld = store.locationData 
    let ldCopy = {...ld}

    switch (action.type) {
        case "fav/SOJOURNS_LIST":
            console.log('tasks LIST_SOJOURNS reducer')
            return { ...store, locationData: action.payload.locationData, locationLoading: false, locationError: null }
        case "fav/SOJOURNS_BEGIN":
        
            return { ...store, locationData: [], locationLoading: true, locationError: null }
        case "fav/SOJOURNS_ERROR":
            return { ...store, locationData: [], locationError: action.error, locationLoading: false }
        case  "fav/SOJOURNS_SUCCESS":
                return { ...store, locationData: action.payload.locationData, locationLoading: false}
        
        /*ac start*/
       
        case "fav/ESAC_BEGIN":   
           
            ldCopy['dataSourceSV'] = []    
            return { ...store, locationData: ldCopy, esacLoading: true, esacError: null }
        case "fav/ESAC_ERROR":
           
            ldCopy['dataSourceSV'] = []    
            return { ...store, locationData: ldCopy, esacError: action.error, esacLoading: false }
        case  "fav/ESAC_SUCCESS":
            
            ldCopy['dataSourceSV'] = action.payload.esacList
            return { ...store, locationData: ldCopy, esacLoading: false}

        /*ac end*/
        default:
            return store
    }
}